import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { error, warn } from './utils/logger';

// CRITICAL: Clear any invalid tokens IMMEDIATELY on app load
// This runs before React even mounts
(function clearInvalidTokens() {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      // Explicitly check for test-token first
      if (token === 'test-token') {
        error('🚨 index.js: Found test-token - clearing immediately!', {
          context: 'token_validation',
          action: 'clear_test_token'
        });
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return;
      }
      // Valid JWTs start with "eyJ" and are at least 50 chars (matching other checks)
      // Real JWTs are typically 150-300+ chars, but 50 is a safe minimum
      const isValid = token.startsWith('eyJ') && token.length >= 50 && !token.includes('test');
      if (!isValid) {
        warn('🚨 Clearing invalid token on app load', {
          context: 'token_validation',
          action: 'clear_invalid_token',
          tokenPrefix: token.substring(0, 20)
        });
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
  } catch (e) {
    error('Error clearing token', {
      context: 'token_validation',
      error: e.message,
      stack: e.stack
    });
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </AuthProvider>
  </React.StrictMode>
);